import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { Company } from 'shared-pages/common/constants';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'orderNo', fieldTitle: t('Αρ. Εντολής'), fieldType: 'TEXT' },
    { fieldName: 'isApproved', fieldTitle: t('Έχει Εγκριθεί'), fieldType: 'TEXT' },
    { fieldName: 'dateOrdered', fieldTitle: t('Ημ/νία Παραγγελίας'), fieldType: 'DATE' },
    { fieldName: 'datePosted', fieldTitle: t('Ημ/νία Παράδοσης'), fieldType: 'DATE' },
    { fieldName: 'notes', fieldTitle: t('Παρατηρήσεις Παραγγελίας'), fieldType: 'TEXT' },
    { fieldName: 'sendDocumentId', fieldTitle: t('Δελτίο Αποστολής'), fieldType: 'TEXT' },
    { fieldName: 'collector.name', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
    {
      fieldName: 'collectionpoint.name',
      fieldTitle: t('Επωνυμία Σημείου'),
      fieldType: 'TEXT',
    },
    { fieldName: 'collectionpoint.addressLine1', fieldTitle: t('Διεύθυνση'), fieldType: 'TEXT' },
    { fieldName: 'collectionpoint.addressLine2', fieldTitle: t('Διεύθυνση 2'), fieldType: 'TEXT' },
    { fieldName: 'collectionpoint.addressArea', fieldTitle: t('Περιοχή'), fieldType: 'TEXT' },
    { fieldName: 'collectionpoint.addressCity', fieldTitle: t('Πόλη'), fieldType: 'TEXT' },
    { fieldName: 'collectionpoint.postalCode', fieldTitle: t('Τ.Κ.'), fieldType: 'TEXT' },
    { fieldName: 'collectionpoint.phone', fieldTitle: t('Τηλέφωνο'), fieldType: 'TEXT' },
    { fieldName: 'collectionpoint.companyVat', fieldTitle: t('Α.Φ.Μ.'), fieldType: 'TEXT' },
    { fieldName: 'collectionpoint.companyTaxOffice', fieldTitle: t('Δ.Ο.Υ.'), fieldType: 'TEXT' },

    { fieldName: 'line1', fieldTitle: t('Συσκευασία 1'), fieldType: 'TEXT' },
    { fieldName: 'line2', fieldTitle: t('Συσκευασία 2'), fieldType: 'TEXT' },
    { fieldName: 'line3', fieldTitle: t('Συσκευασία 3'), fieldType: 'TEXT' },
    { fieldName: 'line4', fieldTitle: t('Συσκευασία 4'), fieldType: 'TEXT' },

    { fieldName: 'isActive', fieldTitle: t('Ενεργή Εγγραφή'), fieldType: 'TEXT' },

    { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
    { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetQuery, { onCompleted: transformData });
    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);
    function transformData(data) {
      const recs = data.getContainersorders.data.map((values) => {
        return {
          ...values,
          isApproved: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
          firstRec: ` ${
            values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.firstUser}`,
          lastRec: ` ${
            values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''
          }  - ${values.lastUser}`,
          line1:
            values.lines && values.lines[0]
              ? `${values.lines[0].containertype.name} - ${values.lines[0].quantity} τεμ.`
              : '',
          line2:
            values.lines && values.lines[1]
              ? `${values.lines[1].containertype.name} - ${values.lines[1].quantity} τεμ.`
              : '',
          line3:
            values.lines && values.lines[2]
              ? `${values.lines[2].containertype.name} - ${values.lines[2].quantity} τεμ.`
              : '',
          line4:
            values.lines && values.lines[3]
              ? `${values.lines[3].containertype.name} - ${values.lines[3].quantity} τεμ.`
              : '',
        };
      });
      const trsData = {
        getContainersorders: { data: recs, recordCount: data?.getContainersorders?.recordCount },
      };
      setResult([get, { loading, data: trsData }]);
    }
    return result;
  }
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export Container Orders',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}

